export default "__VITE_ASSET__VsfzPnRC__"